import { useState } from "react";
import { Row, Col, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import settingsActions from "../../../../redux/settings/actions";
import styles from "./style.module.scss";
import youtube from "../../../../assets/images/youtube.png";
import soundcloud from "../../../../assets/images/soundcloud.png";
import AppleMusic from "../../../../assets/images/applemusic";
import Spotify from "../../../../assets/images/spotify";
import Instagram from "../../../../assets/images/settings/instagram";
import Facebook from "../../../../assets/images/settings/facebook";
import Twitter from "../../../../assets/images/settings/twitter";
import Triller from "../../../../assets/images/settings/triller";
import Snpachat from "../../../../assets/images/settings/snapchat";

const Links = () => {
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state) => ({
    currentUser: state.profile.currentUser,
  }));
  const [connect, setConnect] = useState();
  const [url, setUrl] = useState();
  const [error, setError] = useState();

  const updateUrl = () => {
    if (!url) {
      setError(true);
      return;
    }
    setUrl("");
    setError(false);
    setConnect();
    dispatch({
      type: settingsActions.CONNECT_LINK,
      payload: {
        [connect.toLowerCase()]: url,
      },
    });
  };

  const removeUrl = (con) => {
    setUrl("");
    setError();
    dispatch({
      type: settingsActions.CONNECT_LINK,
      payload: {
        [con]: "",
      },
    });
  };
  return (
    <Row className={styles.linksContainer} justify="space-between" align="top">
      <Col xs={24} sm={24} md={24} lg={12}>
        <h2>Social</h2>
        <div className={styles.item}>
          <div className={styles.logo}>
            <Instagram />
          </div>
          <div className={styles.link}>instagram</div>
          {currentUser.instagram === "" ? (
            <button
              className={styles.connect}
              onClick={() => setConnect("Instagram")}
            >
              Connect
            </button>
          ) : (
            <button
              className={styles.remove}
              onClick={() => removeUrl("instagram")}
            >
              Remove
            </button>
          )}
        </div>
        <div className={styles.item}>
          <div className={styles.logo}>
            <Twitter />
          </div>
          <div className={styles.link}>Twitter</div>
          {currentUser.twitter === "" ? (
            <button
              className={styles.connect}
              onClick={() => setConnect("Twitter")}
            >
              Connect
            </button>
          ) : (
            <button
              className={styles.remove}
              onClick={() => removeUrl("twitter")}
            >
              Remove
            </button>
          )}
        </div>
        <div className={styles.item}>
          <div className={styles.logo}>
            <Facebook />
          </div>
          <div className={styles.link}>facebook</div>
          {currentUser.facebook === "" ? (
            <button
              className={styles.connect}
              onClick={() => setConnect("Facebook")}
            >
              Connect
            </button>
          ) : (
            <button
              className={styles.remove}
              onClick={() => removeUrl("facebook")}
            >
              Remove
            </button>
          )}
        </div>
        <div className={styles.item}>
          <div className={styles.logo}>
            <Triller />
          </div>
          <div className={styles.link}>triller</div>
          {currentUser.triller === "" ? (
            <button
              className={styles.connect}
              onClick={() => setConnect("Triller")}
            >
              Connect
            </button>
          ) : (
            <button
              className={styles.remove}
              onClick={() => removeUrl("triller")}
            >
              Remove
            </button>
          )}
        </div>
        <div className={styles.item}>
          <div className={styles.logo}>
            <Snpachat />
          </div>
          <div className={styles.link}>snapchat</div>
          {currentUser.snapchat === "" ? (
            <button
              className={styles.connect}
              onClick={() => setConnect("Snapchat")}
            >
              Connect
            </button>
          ) : (
            <button
              className={styles.remove}
              onClick={() => removeUrl("snapchat")}
            >
              Remove
            </button>
          )}
        </div>
      </Col>
      <Col xs={24} sm={24} md={24} lg={12}>
        <h2>Music</h2>
        <div className={styles.item}>
          <div className={styles.logo}>
            <Spotify />
          </div>
          <div className={styles.link}>spotify</div>
          {currentUser.spotify === "" ? (
            <button
              className={styles.connect}
              onClick={() => setConnect("Spotify")}
            >
              Connect
            </button>
          ) : (
            <button
              className={styles.remove}
              onClick={() => removeUrl("spotify")}
            >
              Remove
            </button>
          )}
        </div>
        <div className={styles.item}>
          <div className={styles.logo} style={{ paddingTop: 3 }}>
            <AppleMusic />
          </div>
          <div className={styles.link}>apple music</div>
          {currentUser.applemusic === "" ? (
            <button
              className={styles.connect}
              onClick={() => setConnect("AppleMusic")}
            >
              Connect
            </button>
          ) : (
            <button
              className={styles.remove}
              onClick={() => removeUrl("applemusic")}
            >
              Remove
            </button>
          )}
        </div>
        <div className={styles.item}>
          <div className={styles.logo}>
            <img
              src={youtube}
              alt="soundcloud"
              style={{ width: 41, height: 41 }}
            />
          </div>
          <div className={styles.link}>youtube music</div>
          {currentUser.youtube === "" ? (
            <button
              className={styles.connect}
              onClick={() => setConnect("Youtube")}
            >
              Connect
            </button>
          ) : (
            <button
              className={styles.remove}
              onClick={() => removeUrl("youtube")}
            >
              Remove
            </button>
          )}
        </div>
        <div className={styles.item}>
          <div className={styles.logo}>
            <img
              src={soundcloud}
              alt="soundcloud"
              style={{ width: 41, height: 41 }}
            />
          </div>
          <div className={styles.link}>soundcloud</div>
          {currentUser.soundcloud === "" ? (
            <button
              className={styles.connect}
              onClick={() => setConnect("Soundcloud")}
            >
              Connect
            </button>
          ) : (
            <button
              className={styles.remove}
              onClick={() => removeUrl("soundcloud")}
            >
              Remove
            </button>
          )}
        </div>
      </Col>
      <Modal
        title={`Connect your ${connect} account`}
        visible={connect}
        onOk={updateUrl}
        onCancel={() => {
          setConnect(null)
          setUrl(null)
        }}
      >
        <div className={styles.formGroup}>
          <label htmlFor>
            Please set your {connect} url <span>*</span>
          </label>
          <input value={url} onChange={(e) => setUrl(e.target.value)} />
          {error && (
            <span style={{ color: "red", fontSize: "12px" }}>Url Required</span>
          )}
        </div>
      </Modal>
    </Row>
  );
};

export default Links;
